import { ProductCard } from "src/admin/modules/b2b-gate-order/components/ExonnHub/components/ProductCard/ProductCard.tsx";
import * as styles from "./ProductCollection.style.ts";
import { useExonnHubCatalogParams } from "src/admin/modules/b2b-gate-order/components/ExonnHub/hooks/useExonnHubCatalogParams.ts";
import { useExonnHubCatalog } from "src/admin/modules/b2b-gate-order/components/ExonnHub/hooks/useExonnHubCatalog.tsx";
import { keepPreviousData } from "@tanstack/react-query";
import { observer } from "mobx-react-lite";

export const ProductCollection = observer(() => {
  const listParams = useExonnHubCatalogParams();

  const { data: catalogData } = useExonnHubCatalog(listParams, {
    placeholderData: keepPreviousData,
  });

  const items = catalogData?.data || [];

  return (
    <div css={styles.root}>
      {items.map((product) => (
        <ProductCard key={product.id} data={product} />
      ))}
    </div>
  );
});
